import React from "react";
import styles from "src/assets/styles/requestCall/check-boxes.module.scss";

const CheckBox = ({
  name,
  labelComponent,
  label,
  value,
  onChange,
  hasError,
}) => {
  return (
    <>
      <label
        className={`${styles.container} ${hasError ? styles.hasError : ""}`}
      >
        {/* renders label as normal text or text with onclick for download file or something */}
        {labelComponent ? labelComponent : label}

        <input
          type="checkbox"
          name={name}
          checked={value}
          onChange={onChange}
        />
        <span class={styles.checkmark}></span>
      </label>
    </>
  );
};

export default CheckBox;
